import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'antd';

import withFieldWrapper from '../hocs/withFieldWrapper';

class CheckboxComponent extends Component {
    static propTypes = {
        input: PropTypes.object,
        text: PropTypes.string,
        onChange: PropTypes.func
    };

    onChange = e => this.props.onChange(e.target.checked);

    render() {
        const { input: { value, name }, text } = this.props;

        return <Checkbox
            checked={!!value}
            onChange={this.onChange}
            name={name}>
            { text }
        </Checkbox>
    }
}

export default withFieldWrapper(CheckboxComponent);
